export default __webpack_public_path__ + "static/media/case3 (3).0fcb5266.jpg";